import isMoment from 'utils/predicates/isMoment.util';

const isDateWorthy = (value) => {
  if (value === null) return false;
  if (void 1 === value) return false;
  if (value === '') return false;

  if (value instanceof Date) return true;

  if (Number.isFinite(value)) return true;
  if (typeof value === 'string') return true;

  // noinspection RedundantIfStatementJS
  if (isMoment(value)) return true;

  return false;
};

export default isDateWorthy;
